import languageSlice from './languageSlice';

export * from './thunks';

export default languageSlice;
